import { create } from 'zustand';
import api from '../utils/api';

const idOf = (entry) => (typeof entry === 'object' && entry ? entry._id : entry);

const useWishlistStore = create((set, get) => ({
  wishlist: [],
  ids: new Set(),

  fetchWishlist: async () => {
    try {
      const data = await api.get('/wishlist');
      const wishlist = Array.isArray(data.wishlist) ? data.wishlist : [];
      const ids = new Set(Array.isArray(data.allIds) ? data.allIds : wishlist.map(p => idOf(p)));
      set({ wishlist, ids });
    } catch {}
  },

  toggle: async (productId) => {
    try {
      const data = await api.post(`/wishlist/toggle/${productId}`);
      const wishlist = Array.isArray(data.wishlist) ? data.wishlist : [];
      set({ wishlist, ids: new Set(wishlist.map(p => idOf(p))) });
      return data.added;
    } catch {}
  },

  isInWishlist: (productId) => get().ids.has(productId),
}));

export default useWishlistStore;
